"use client";
import { useState as w, useCallback as a } from "react";
import { fileMatchesAccept as J } from "../../../utils/utils.mjs";
function K(n) {
  return n == null ? [] : Array.isArray(n) ? n : [n];
}
function z(n) {
  return n.length > 0;
}
const Q = (n, L = {}) => {
  const { accept: f, maxSizeBytes: m, multiple: s, maxFiles: x, onFileSelected: g, error: P, onError: _, value: F } = L, p = F !== void 0, [S, d] = w([]), [T, y] = w(!1), [B, l] = w(null), [D, i] = w(null), $ = K(F), h = p ? $ : S, C = h.length, b = s ? z(h) ? h : null : h[0] ?? null, k = P ?? B, j = T ? "loading" : k ? "error" : z(h) ? "success" : "default", c = a(
    (r, e, o) => {
      const t = _ == null ? void 0 : _({ type: r, file: e, defaultMessage: o });
      return typeof t == "string" ? t : o;
    },
    [_]
  ), E = a(
    (r) => {
      if (f != null && f.length && !J(r, f)) {
        const e = `Unsupported file type. Please upload a ${f.join(", ")} file.`;
        return i("unsupported_type"), l(c("unsupported_type", r, e)), "unsupported_type";
      }
      if (m && r.size > m) {
        const e = `File exceeds the ${Math.round(m / 1024 / 1024)} MB limit. Please upload a smaller file.`;
        return i("file_too_large"), l(c("file_too_large", r, e)), "file_too_large";
      }
      return null;
    },
    [f, m, c]
  ), u = a(() => {
    d([]), y(!1), l(null), i(null), n.current && (n.current.value = "");
  }, [n]), U = a(() => {
    var r;
    (r = n.current) == null || r.click();
  }, [n]), M = a(
    async (r) => {
      if (E(r)) {
        p || d([]);
        return;
      }
      if (p || d([r]), l(null), i(null), !!g) {
        y(!0);
        try {
          await g(r);
        } catch (o) {
          const t = o instanceof Error ? o.message : "An error occurred processing the file";
          i("processing_error"), l(c("processing_error", r, t));
        } finally {
          y(!1);
        }
      }
    },
    [E, g, c, p]
  ), v = a(
    async (r) => {
      if (x && C + r.length > x) {
        const t = "Maximum files added";
        i("too_many_files"), l(c("too_many_files", r[0], t));
        return;
      }
      const e = [];
      let o = !1;
      for (const t of r)
        E(t) ? o = !0 : e.push(t);
      if (o || (l(null), i(null)), p || d((t) => [...t, ...e]), !(!g || e.length === 0)) {
        y(!0);
        try {
          await g(e);
        } catch (t) {
          const A = t instanceof Error ? t.message : "An error occurred processing the files";
          i("processing_error"), l(c("processing_error", e[0], A));
        } finally {
          y(!1);
        }
      }
    },
    [E, x, C, g, c, p]
  ), q = a(
    async (r) => {
      const e = r.target.files;
      if (!e || e.length === 0) {
        s || u();
        return;
      }
      s ? await v(Array.from(e)) : await M(e[0]);
    },
    [s, M, v, u]
  ), G = a(
    async (r) => {
      if (r.length === 0) {
        s || u();
        return;
      }
      s ? await v(Array.from(r)) : await M(r[0]);
    },
    [s, M, v, u]
  ), H = a(
    (r) => {
      s && (d((e) => {
        const o = e.filter((t, A) => A !== r);
        return o.length === 0 && u(), o;
      }), l(null), i(null));
    },
    [s, u]
  );
  return { state: j, file: b, error: k, errorType: D, handleChange: q, handleDrop: G, openFilePicker: U, reset: u, removeFile: H };
};
export {
  Q as useFileInput
};
